import { startOfDay, getHours, getMinutes, getSeconds, add } from 'date-fns';
import { convertZonedDateToSystemDate, convertSystemDateToZonedDate } from './DateUtils2.js';

/**
 * Copy the time from the source date into target date regardless of the timezone
 * @param sourceDate
 * @param targetDate
 * @returns
 */
const setTimeToDay = (sourceDate, targetDate) => {
    const systemTargetDate = convertZonedDateToSystemDate(targetDate);
    const systemSourceDate = convertZonedDateToSystemDate(sourceDate);
    const targetStartDate = startOfDay(systemTargetDate);
    const hoursToAdd = getHours(systemSourceDate);
    const minutesToAdd = getMinutes(systemSourceDate);
    const secondsToAdd = getSeconds(systemSourceDate);
    const newDate = add(targetStartDate, {
        hours: hoursToAdd,
        minutes: minutesToAdd,
        seconds: secondsToAdd,
    });
    return convertSystemDateToZonedDate(newDate);
};

export { setTimeToDay };
